import { Component, Injector, OnInit } from '@angular/core';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';


@Component({
  selector: 'app-show-package-consumed-items',
  templateUrl: './show-package-consumed-items.component.html',
  styleUrls: ['./show-package-consumed-items.component.scss'],
  standalone: false
})
export class ShowPackageConsumedItemsComponent implements OnInit {
  container: any = {};
  fields: Array<any> = [];
  config: any = {
    viewAll: false,
    hideSearchBox: true,
    hideResult: true,
    allowPagination: false,
    customButtonsAllowed: false,
    noCount: true,
    resource: 'package_consumed_items'
  };
  bulkActionsConfig: any = {
    key: 'id',
    button: [{ label: 'Send Selected Service(s)' }]
  };
  showBillingCatogory = false
  previewBillingItems: Array<any> = [];
  previewCurrentTotalAmount: number = 0;
  previewNewTotalAmount: number = 0;

  constructor(
    public injector: Injector,
    public loader: LoaderService,
    private dialogConfig: DialogConfig,
    private baseService: BaseService,
    public dialog: DialogRef,
    public alerts: AlertsService
  ) { }

  ngOnInit(): void {
    this['data'] = this.dialogConfig;
    this.container.items = { resource: [] };
    this.showBillingCatogory = this['data'].data.data.hasOwnProperty('showBillingCatogory')
    this.container.current_index = this['data'].data.data.hasOwnProperty('event') ? this['data'].data.data.event.index : null;
    if (this.showBillingCatogory) {
      this.showPrice()
    }
    else {
      // retain previously sent services as checked when the popup is reopened (#203009)
      if (this['data'].data.data.selected_items && this['data'].data.data.selected_items.length > 0) {
        this.config.selected_items = this['data'].data.data.selected_items;
      }
      this.baseService.getResourceDef('package_consumed_items', (resourceDef: any) => {
        if (resourceDef && resourceDef.list) {
          this.fields = resourceDef.list.fields;
        }
      });
      this.getPackageItems();
    }
  }

  showPrice(){
    this.loader.showSpinner();
    this.baseService.action(this['data'].data.data.data, 'PREVIEW_BILLING_CATEGORY_CHANGE', 'billing', 'billing_category_details').subscribe(
        (res: any) => {
          if (res.errCode == 0 && res.resource && res.resource.length > 0 && res.resource[0].extra_data) {
            let extraData = res.resource[0].extra_data;
            this.previewBillingItems = extraData.preview_billing_items || [];
            this.previewCurrentTotalAmount = extraData.preview_current_total_amount || 0;
            this.previewNewTotalAmount = extraData.preview_new_total_amount || 0;
          } else if (res.errCode == -1) {
            this.alerts.error(res.message);
          }
          this.loader.hideSpinner();
        }, () => {
          this.loader.hideSpinner();
        })
  }

  getPackageItems() {
    this.loader.showSpinner();
    let session_data = JSON.parse(sessionStorage.getItem('currentData'));
    let args = 'bill_no:' + session_data['bill_no'] + ",uhId:" + session_data['uhId'] + ",admissionId:" + session_data['admissionId'];
    this.baseService.getData({ args }, '', 'billing_item', 'billing', 'GET_BILLINGITEM_FOR_PACKAGE').subscribe((res: any) => {
      if (res.errCode == 0 && res.resource && res.resource.length > 0) {
        this.container.items = { resource: res.resource };
      } else if (res.errCode == -1) {
        this.alerts.error(res.message);
      }
      this.loader.hideSpinner();
    }, () => {
      this.loader.hideSpinner();
    });
  }

  onSelectionConfirmed(selectedItems: any[]) {
    if (!selectedItems || selectedItems.length == 0) {
      this.alerts.error('Please select at least one service to cancel from the package.');
      return;
    }
    this.dialog.close({ items: selectedItems, event: this.container.current_index });
  }
}
